import { useQuery } from '@tanstack/react-query'
import { fetchKpis } from './api'

// Analytics query keys. The report is keyed on the selected month so
// navigating months refetches rather than serving a stale period.
export const KPIS_KEY = ['analytics', 'kpis'] as const

export const kpisKey = (month?: string) => [...KPIS_KEY, month ?? 'current'] as const

export function useKpis(month?: string) {
  return useQuery({
    queryKey: kpisKey(month),
    queryFn: () => fetchKpis(month),
  })
}
